<template>
  <div class="main">
    <div class="banner"></div>
    <div class="wrap">
      <Breadcrumb class="bread"
                  separator=">">
        <!--<BreadcrumbItem to="/">-->
        <!--<img class="bread-icon"-->
        <!--src="../assets/images/icon-location.png" />首页-->
        <!--</BreadcrumbItem>-->
        <BreadcrumbItem to="/successCase/0">服务案例</BreadcrumbItem>
        <!-- <div @click="$router.go(-1)">服务案例</div> -->
        <BreadcrumbItem class="bread-last">{{eg_title}}</BreadcrumbItem>
      </Breadcrumb>
      <!-- <Bread class="bread"></Bread>   -->
      <h2 class="title" style="display: flex;justify-content: center;">{{eg_title}}</h2>
      <p class="info" style="color: #c09d58;">化名：{{eg_name}}<span style="margin-left: 35px;"></span>年龄：{{eg_age}}<span style="margin-left: 35px;"></span>病症：{{eg_disease_name}}</p>
      <p class="info" style="color: #c09d58;">就诊医院：{{eg_hospital}}</p>
      <div class="editor">
        <div v-html="eg_content"
             class="content"></div>
        <!-- <div v-for="(eg,index) in eg_content" :key="index">
                    <p v-if="eg.text">{{eg.text}}</p>
                    <img v-else :src="baseURL + eg.img" alt="">
                </div> -->

      </div>

    </div>
  </div>
</template>
<script>
// import Bread from '@/components/Bread.vue'
import * as apis from '@/api/success'
import { baseURL } from '@/api/axios'
export default {
  data () {
    return {
      eg_title: '',
      eg_name: '',
      eg_age: 0,
      eg_disease_name: '',
      eg_hospital: '',
      eg_content: '',
      baseURL: baseURL
    }
  },
  components: {
    // Bread
  },
  mounted () {

    let id = this.$route.params.id;
    // console.log(id);
    this.getDetailsInfo(id);
  },
  methods: {
    async getDetailsInfo (id) {
      try {
        let data = {
          id: id
        }
        let res = await apis.getCaseDetail(data);
        if (res.code == 200) {
          this.eg_title = res.data.title;
          this.eg_name = res.data.alias;
          this.eg_age = res.data.age;
          this.eg_disease_name = res.data.disease_name;
          this.eg_hospital = res.data.hospital;
          this.eg_content = res.data.article_content;
          // let arr = res.data.article_content.content;
          // let str = arr.filter(item => {
          //     if(item.hasOwnProperty('text')){
          //         return '<p>' + item.text + '</p>';
          //     }
          //     if(item.hasOwnProperty('img')){
          //         return '<img src="'+ item.img +'"/>';
          //     }
          // }).join(",");
          // console.log(str);
          // this.eg_content = str;
          // console.log(this.eg_content)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  height: 250px;
  background: url('../assets/images/successCase/banner.png') no-repeat center;
}
.main {
  width: 100% !important;
  .wrap {
    background-color: #fff;
    width: 980px;
    overflow: auto;
    margin: 0 auto;
    .bread {
      margin: 50px 50px 14px;
    }
    .title {
      font-size: 28px;
      color: #333130;
      line-height: 52px;
      text-align: center;
      font-weight: normal;
      margin-bottom: 32px;
      margin: 0 0 10px 0;
    }
    .info {
      font-size: 20px;
      color: #ae1e10;
      line-height: 26px;
      text-align: center;
      margin-bottom: 12px;
    }
    .editor {
      margin-top: 30px;
      margin-bottom: 200px;
      p {
        font-size: 22px;
        color: #333130;
        line-height: 38px;
        text-indent: 44px;
        margin-bottom: 50px;
      }
      img {
        width: 970px;
        height: auto;
        margin-bottom: 50px;
      }
    }
  }
}
.content {
  padding: 0 50px;
}
</style>

